import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class PostalballotService {

  constructor( private httpService: HttpService) { }

    samplePbRecord(object) {
        console.log('object', object);
        var request = {
            URL: 'postalballot/pbEntry',
            DATA: object
        };
        return this.httpService.post(request);
    }
    getRegisterDirector(object) {
        var registerList = {
            URL: "postalballotroute/getpostalballot/5cee33d225242e023acfb2d4",
            DATA: object
        }
        return this.httpService.post(registerList);
    }
    removepostalballotdetails(_id) {
        var request = {
            URL: "postalballot/deletadetails/" + _id
        }
        return this.httpService.get(request);
    }

    updatepostalballot(_id) {
        var editlist = {
            URL: "postalballot/update/" + _id,
        }
        return this.httpService.get(editlist);
    }


    updatePostalballot(object, id) {
        var request = {
            URL: "postalballot/updatePostalballot/" + id,
            DATA: object
        }
        return this.httpService.post(request);
    }
    generatePostalballotDocument(object) {
        var request = {
            URL: "postalballot/generatePostalballotDocument",
            DATA: object
        }
        return this.httpService.post(request);
    }

    downloadPostalballotFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "postalballot/downloadDocument/" + id + "/" + type +"/" + token;
    }
    downloadPostalballotPdfFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "postalballot/downloadPdfDocument/" + id + "/" + type +"/" + token;
    }
}


